var _rect, _circle, _circle2, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLexiliteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#0C0D0E",
    rx: 24
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 60,
    stroke: "#7D8C6B",
    stroke_width: 1.5,
    fill: "none",
    opacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 40,
    stroke: "#DCCA87",
    stroke_width: 2,
    fill: "none",
    opacity: 0.6
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "100,75 122,115 78,115",
    fill: "#DCCA87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLexiliteLogo);
export default __webpack_public_path__ + "static/media/lexilite_logo.23f22b2278024f3f26b6b8ee7ed142e6.svg";
export { ForwardRef as ReactComponent };